import { gql } from '@apollo/client';

import { GetContractsForDeal } from './__generated__/getContractsForDeal';

// Shared by every consumer of this query's `getContractsForDeal` selection -- centralized here,
// next to the query that produces it, instead of each consumer re-deriving an identical alias.
export type GetContractsForDeal_getContractsForDeal = NonNullable<
  NonNullable<GetContractsForDeal>['getContractsForDeal']
>[number];
export type Contract = NonNullable<GetContractsForDeal_getContractsForDeal>;

const GET_CONTRACTS_FOR_DEAL = gql`
  query GetContractsForDeal($dealId: ID!) {
    getContractsForDeal(dealId: $dealId) {
      contractId
      contractVersion
      data {
        buyerSigned
        sellerSigned
        buyerReferenceText
        sellerReferenceText
        readyToSignBuyer
        readyToSignSeller
      }
      originalFileName
      contractSigningError
    }
  }
`;

export default GET_CONTRACTS_FOR_DEAL;
